import React, {Component} from 'react';
import styled from 'styled-components';
import Section from './Section';
import { device } from '../utils/devices';

const Table = styled.div`
  font-size: 14px;

  @media ${device.laptop} {
    display: grid;
    grid-template-columns: 1fr 1.5fr;
  }
`;

const Column = styled.div`
  padding: 5vw;

  @media ${device.laptop} {
    padding: 4rem;
  }

  h2 {
    font-weight: 200;
    font-size: 24px;

    @media ${device.laptop} {
      font-size: 36px;
    }
  }

  ul {
    padding: 0;
    list-style: none;
  }

  li:before {
    content: "\u231D";
    line-height: 36px;
    margin-right: .5rem;
  }

  &:first-of-type {
    background: ${props => props.theme.light}
  }

  &:last-of-type {
    li {
      display: flex;
      justify-content: space-between;
      align-items: center;

      span {
        flex-grow: 1;
        margin: 0 1rem;
        display: block;
        background-image: linear-gradient(to right, black 33%, rgba(255,255,255,0) 0%);
        background-position: bottom;
        background-size: 4px 1px;
        height: 1px;
        background-repeat: repeat-x;
      }
    }
  }
`;

export default class Equipment extends Component {
  render(){
    return (
      <Section title='Equipment'>
        <Table>
          <Column>
            <ul>
              <h2>Included Grip</h2>
              <li>Matthews C-Stands x4</li>
              <li>Steel Spring A-Clamp x8</li>
              <li>Apple Box x2</li>
              <li>Extension cords x4</li>
              <li>4x8 V-Flats x2</li>
              <li>Single white foamcore sheet x2</li>
              <li>Glamcor Classic Elite Beauty light x1</li>
              <li>Folding tables; 1 square + 1 rectangle</li>
            </ul>
          </Column>
          <Column>
            <ul>
              <h2>Expendables</h2>
              <li>Gaffer Tape <span></span> $30</li>
              <li>1 pull of seamless - White, black, grey 12' wide <span></span> $20</li>
              <li>Additional color seamless in 9’, more colors upon request <span></span> $20</li>
              <li>Textured backdrop fabric available <span></span> $15</li>
            </ul>
            <ul>
              <h2>Equipment for Rent</h2>
              <li>Arri Lite 1000 x2 <span></span> $30</li>
              <li>Arri 650 Plus x2 <span></span> 20</li>
              <li>Profoto D4 2400 power pack <span></span> $60</li>
              <li>Profoto D4 Head x4<span></span> $40</li>
              <li>Impact light stand x5<span></span> $8</li>
              <li>Air-Cushioned light stand x3<span></span> $8</li>
              <li>Pocket wizard x4 (per set)<span></span> $25</li>
              <li>Sync cord<span></span> $5</li>
              <li>Profoto medium 3x3 softbox<span></span> $50</li>
              <li>Elinchrom 74” Octa Softbox<span></span> $60</li>
              <li>Profoto Snoot x1<span></span> $25</li>
              <li>Translucent white umbrella x1<span></span> $20</li>
              <li>Profoto white softlight beauty dish<span></span> $25</li>
            </ul>
          </Column>
        </Table>
      </Section>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/Equipment.js